import bookmarkReducer from "./bookmarkReducer";
import menuReducer from "./menuReducer";

/**
 * Function: combineReducers
 * Is used to combine reducers that will be provided to store
 * @param {{profile: function}} reducers
 */
function combineReducers(reducers) {
  const reducerKeys = Object.keys(reducers);

  return (state, action) => {
    const nextState = {};

    for (let i = 0; i < reducerKeys.length; i += 1) {
      // Get the current key name
      const key = reducerKeys[i];

      // Get the current reducer
      const reducer = reducers[key];
      // Get the the previous state
      const previousStateForKey = state[key];

      // Get the next state by running the reducer
      const nextStateForKey = reducer(previousStateForKey, action);

      // Update the new state for the current reducer
      nextState[key] = nextStateForKey;
    }

    return nextState;
  };
}

export default combineReducers({
  bookmark: bookmarkReducer,
  menu: menuReducer,
});
